module.exports = __webpack_public_path__ + "static/media/image-placeholder-files.c1a46607.jpg";